var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatisfacaoQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 8,
    fill: "url(#paint0_linear_5_4377)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 40.2C39.1967 40.2 39.5408 40.0542 39.8325 39.7625C40.1242 39.4708 40.27 39.1267 40.27 38.73C40.27 38.3333 40.1242 37.9892 39.8325 37.6975C39.5408 37.4058 39.1967 37.26 38.8 37.26C38.4033 37.26 38.0592 37.4058 37.7675 37.6975C37.4758 37.9892 37.33 38.3333 37.33 38.73C37.33 39.1267 37.4758 39.4708 37.7675 39.7625C38.0592 40.0542 38.4033 40.2 38.8 40.2ZM37.75 35.72H39.85C39.85 35.0433 39.92 34.5475 40.06 34.2325C40.2 33.9175 40.5267 33.5033 41.04 32.99C41.74 32.29 42.2067 31.7242 42.44 31.2925C42.6733 30.8608 42.79 30.3533 42.79 29.77C42.79 28.72 42.4225 27.8625 41.6875 27.1975C40.9525 26.5325 39.99 26.2 38.8 26.2C37.8433 26.2 37.0092 26.4683 36.2975 27.005C35.5858 27.5417 35.09 28.2533 34.81 29.14L36.7 29.91C36.91 29.3267 37.1958 28.8892 37.5575 28.5975C37.9192 28.3058 38.3333 28.16 38.8 28.16C39.36 28.16 39.815 28.3175 40.165 28.6325C40.515 28.9475 40.69 29.3733 40.69 29.91C40.69 30.2367 40.5967 30.5458 40.41 30.8375C40.2233 31.1292 39.8967 31.4967 39.43 31.94C38.66 32.6167 38.1875 33.1475 38.0125 33.5325C37.8375 33.9175 37.75 34.6467 37.75 35.72ZM30.4 44.4C29.63 44.4 28.9708 44.1258 28.4225 43.5775C27.8742 43.0292 27.6 42.37 27.6 41.6V24.8C27.6 24.03 27.8742 23.3708 28.4225 22.8225C28.9708 22.2742 29.63 22 30.4 22H47.2C47.97 22 48.6292 22.2742 49.1775 22.8225C49.7258 23.3708 50 24.03 50 24.8V41.6C50 42.37 49.7258 43.0292 49.1775 43.5775C48.6292 44.1258 47.97 44.4 47.2 44.4H30.4ZM30.4 41.6H47.2V24.8H30.4V41.6ZM24.8 50C24.03 50 23.3708 49.7258 22.8225 49.1775C22.2742 48.6292 22 47.97 22 47.2V27.6H24.8V47.2H44.4V50H24.8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_4377",
    x1: 72,
    y1: 72.1749,
    x2: 0,
    y2: 0.174906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000E4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfacaoQuestion);
export default __webpack_public_path__ + "static/media/SatisfacaoQuestion.e6ec13fbc0e92314d30b25b0846e39fc.svg";
export { ForwardRef as ReactComponent };